var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form-modelCols',{staticClass:"pb-3 mx-1 pt-2",attrs:{"model":_vm.getFormModel(_vm.m.config.agentObjects.fieldsForm.split(',')),"values":_vm.data,"errors":_vm.errors,"config":{ dense: true, readonly: _vm.readonly, hideDetails: 'auto' }},on:{"validate":function($event){_vm.validate($event);
      _vm.doWatch($event);}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }